import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodeigniterComponent } from './simple-icons-codeigniter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodeigniterComponent ],
    exports:      [ SimpleIconsCodeigniterComponent ],
    bootstrap:    []
})
export class SimpleIconsCodeigniterModule {}
